<template>
	<div class="base-regulations">
		<div class="regulations">
			<div class="base-menu">
				<div class="head">
					<div class="en">REGULATIONS</div>
					<div class="ch">规章制度</div>
					<div class="line">
						<img src="/img/you_line.png" draggable="false" />
					</div>
				</div>
				<div :class="'menuItem' + (breadcrumb.value==item.value?' hover':'')" v-for="item in menuList">
					<div @click="setContextPage(item)">{{item.name}} </div>
					<i class="el-icon-right"></i>
				</div>
			</div>
			<div class="right-context">
				<el-breadcrumb separator-class="el-icon-arrow-right" class="base-nav">
					<el-breadcrumb-item :to="{ path: '/' }"><span class="shuxian">&nbsp;</span>网站首页</el-breadcrumb-item>
					<el-breadcrumb-item>规章制度</el-breadcrumb-item>
					<el-breadcrumb-item>{{breadcrumb.name}}</el-breadcrumb-item>
				</el-breadcrumb>

				<div class="base-context">
					<component v-if="path" is='contextPage'></component>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	export default {
		data() {
			return {
				menuList: [{
					name: '资金管理办法',
					value: 'money'
				}, {
					name: '项目管理办法',
					value: 'project'
				}, {
					name: '实训基地管理办法',
					value: 'simbase'
				}, {
					name: '教学管理办法',
					value: 'edu'
				}],
				path: '',
				breadcrumb: {
					name: '资金管理办法',
					value: 'money'
				}
			}
		},
		created() {

		},
		methods: {
			loadPage(path) {
				this.path = path
				Vue.component('contextPage', require(`./components/${path}.vue`).default)
			},
			setContextPage(val) {
				this.breadcrumb = val
				this.loadPage(val.value)
			},
			setBreadcrumb(val) {
				this.menuList.map(item => {
					if (item.value == val) {
						this.breadcrumb = item
					}
				})
			},
			init() {
				this.setBreadcrumb('money')
				this.loadPage('money')
			}
		},
		mounted() {
			this.init()
			//页面加载滚动条 到顶部
			document.querySelector(".el-container").scrollTop = 0
		}
	}
</script>

<style lang="scss">
	.base-regulations {
		background-color: #F3F3F3;
		padding: 24px 0;

		.regulations {
			width: 1440px;
			margin: 0 auto;

			.base-menu {
				padding: 30px 0;
				width: 300px;
				height: 850px;
				border-radius: 10px;
				background-color: #7D3811;
				float: left;
				// position: sticky;
				// top: 800px;

				.head {
					padding: 0 20px;

					.en {
						font-size: 36px;
						color: #BE9B88;
					}

					.ch {
						padding: 5px 0px;
						font-size: 26px;
						color: #fff;
					}
				}

				.menuItem {
					height: 95px;
					border-bottom: 1px solid #e1e1e1;
					color: #ffffff;
					font-size: 20px;
					padding-left: 20px;
					line-height: 95px;
					cursor: pointer;

					.el-icon-right {
						display: none;
						float: right;
						margin-top: -55px;
						margin-right: 30px;
					}
				}

				.hover,
				.menuItem:hover {
					background-color: #EFCAB0;
					border-bottom: 1px solid #7D3811;
					color: #7D3811;

					.el-icon-right {
						display: inline;
					}
				}
			}

			.right-context {
				float: left;
				margin-left: 40px;
				width: 1100px;

				.base-nav {
					margin-bottom: 20px;
					font-size: 16px;

					.shuxian {
						width: 2px;
						background-color: #7D3811;
						margin-right: 5px;
					}

					.is-link:hover {
						color: #7D3811 !important;
					}
				}

				.base-context {
					height: calc(100vh - 74px);
					background-color: #fff;
					padding: 10px 20px;
					border-radius: 8px;
					overflow-y: auto;
				}
			}
		}
	}
</style>